import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./styles/App.scss";
import { Analytics } from "@vercel/analytics/react";

// Lazy load page components
const HomePage = React.lazy(() => import("./components/HomePage"));
const Commands = React.lazy(() => import("./components/Commands"));

// Scroll to top on route change
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    if (location.pathname) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Mark app as loaded after initial render
    setIsLoaded(true);
  }, []);

  return (
    <div className="container">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/commands" element={<Commands />} />
      </Routes>

      {isLoaded && <Analytics />}
    </div>
  );
};

export default App;
